export const ALLOWED_COUNTRIES: Record<string, string[]> = {
  wellamoon: ['US', 'CA', 'MX', 'FR', 'IT', 'NO', 'AT', 'ES'],
  default: [
    'AO',
    'AR',
    'AM',
    'AU',
    'AT',
    'BD',
    'AL',
    'BE',
    'BO',
    'BA',
    'BW',
    'BR',
    'BN',
    'BG',
    'BF',
    'KH',
    'CA',
    'CO',
    'CR',
    'CI',
    'HR',
    'CY',
    'CZ',
    'DK',
    'DJ',
    'EC',
    'EE',
    'ET',
    'FJ',
    'FI',
    'FR',
    'GE',
    'DE',
    'GH',
    'GI',
    'GR',
    'GT',
    'HN',
    'HU',
    'IS',
    'IN',
    'ID',
    'IE',
    'IL',
    'IT',
    'JP',
    'JO',
    'CH',
    'ES',
    'GB',
    'KE',
    'KG',
    'KZ',
    'LK',
    'LU',
    'LV',
    'MA',
    'MD',
    'MK',
    'MT',
    'MU',
    'MW',
    'MX',
    'MZ',
    'NA',
    'NL',
    'NO',
    'NP',
    'NR',
    'NZ',
    'PA',
    'PE',
    'PH',
    'PL',
    'PR',
    'PT',
    'PY',
    'RO',
    'RS',
    'RW',
    'SC',
    'SE',
    'SG',
    'SI',
    'SK',
    'SN',
    'TH',
    'TN',
    'TR',
    'UG',
    'US',
    'UY',
    'UZ',
    'ZA',
    'ZM',
  ],
};
